var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        staticClass: "mt-5",
        attrs: { "has-line": "", title: "Información de Vigencia" }
      }),
      _c("div", { staticClass: "row mx-2" }, [
        _c("div", { staticClass: "col-md-3 col-sm-12" }, [
          _c("span", { staticClass: "data-label" }, [_vm._v("Año Fiscal:")]),
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c("p", { staticClass: "data" }, [
              _vm._v(" " + _vm._s(_vm.value.fiscalYearDescription) + " ")
            ])
          ])
        ]),
        _c("div", { staticClass: "col-md-3 col-sm-12" }, [
          _c("span", { staticClass: "data-label" }, [
            _vm._v("Vigencia de Contrato Previo:")
          ]),
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c("p", { staticClass: "data" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$formatDate(_vm.value.orig_EffecteFromDate)) +
                  " - " +
                  _vm._s(_vm.$formatDate(_vm.value.orig_EffectiveToDate)) +
                  " "
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "col-md-6 col-sm-12" }, [
          !_vm.isReadOnly
            ? _c("div", [
                _c("div", { staticClass: "data-label" }, [
                  _vm._v("Fecha de Vigencia:")
                ]),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center mt-1" },
                  [
                    _c("validation-provider", {
                      staticClass: "mr-2",
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-date-picker", {
                                  staticClass: "custom-date-picker__extended",
                                  attrs: {
                                    "custom-error-msg":
                                      _vm.errorMsg.dateRequired,
                                    error: errors[0],
                                    "min-date": _vm.value.orig_EffectiveToDate,
                                    "open-date": _vm.openDate
                                  },
                                  model: {
                                    value: _vm.value.effectiveFromDate,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.value,
                                        "effectiveFromDate",
                                        $$v
                                      )
                                    },
                                    expression: "value.effectiveFromDate"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        342804733
                      )
                    }),
                    _c("span", { staticClass: "mx-1 font-weight-bold" }, [
                      _vm._v("-")
                    ]),
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-date-picker", {
                                  staticClass: "custom-date-picker__extended",
                                  attrs: {
                                    "custom-error-msg":
                                      _vm.errorMsg.dateRequired,
                                    error: errors[0],
                                    "min-date": _vm.value.orig_EffectiveToDate,
                                    "open-date": _vm.openDate
                                  },
                                  model: {
                                    value: _vm.value.effectiveToDate,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.value,
                                        "effectiveToDate",
                                        $$v
                                      )
                                    },
                                    expression: "value.effectiveToDate"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2263815728
                      )
                    })
                  ],
                  1
                )
              ])
            : _vm.editing
            ? _c("div", [
                _c("div", { staticClass: "data-label" }, [
                  _vm._v("Fecha de Vigencia:")
                ]),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center mt-1" },
                  [
                    _c(
                      "div",
                      { staticClass: "mr-1" },
                      [
                        _c("custom-date-picker", {
                          staticClass: "custom-date-picker__extended",
                          attrs: {
                            "min-date": _vm.value.orig_EffectiveToDate,
                            "open-date": _vm.openDate,
                            placeholder: "DD/MM/YYYY"
                          },
                          model: {
                            value: _vm.draft.effectiveFromDate,
                            callback: function($$v) {
                              _vm.$set(_vm.draft, "effectiveFromDate", $$v)
                            },
                            expression: "draft.effectiveFromDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c("span", { staticClass: "mx-1 font-weight-bold" }, [
                      _vm._v("-")
                    ]),
                    _c(
                      "div",
                      { staticClass: "mr-2" },
                      [
                        _c("custom-date-picker", {
                          staticClass: "custom-date-picker__extended",
                          attrs: {
                            "min-date": _vm.value.orig_EffectiveToDate,
                            "open-date": _vm.openDate,
                            placeholder: "DD/MM/YYYY"
                          },
                          model: {
                            value: _vm.draft.effectiveToDate,
                            callback: function($$v) {
                              _vm.$set(_vm.draft, "effectiveToDate", $$v)
                            },
                            expression: "draft.effectiveToDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c("action-button", {
                      staticClass: "mr-2 vigency-edit-btn",
                      attrs: {
                        i: "fas fa-save",
                        title: "Guardar",
                        variant: "outline-success"
                      },
                      on: { click: _vm.onSave }
                    }),
                    _c("action-button", {
                      staticClass: "vigency-edit-btn",
                      attrs: {
                        i: "fas fa-times",
                        title: "Cancelar",
                        variant: "outline-secondary"
                      },
                      on: { click: _vm.onCancel }
                    })
                  ],
                  1
                )
              ])
            : _c("div", [
                _c("div", { staticClass: "data-label" }, [
                  _vm._v("Fecha de Vigencia:")
                ]),
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("p", { staticClass: "data" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$formatDate(_vm.value.effectiveFromDate)) +
                        " - " +
                        _vm._s(_vm.$formatDate(_vm.value.effectiveToDate)) +
                        " "
                    ),
                    _vm.canEditVigency
                      ? _c("em", {
                          staticClass: "fas fa-edit color-primary-1 ml-1",
                          staticStyle: { cursor: "pointer" },
                          attrs: { title: "Editar vigencia" },
                          on: { click: _vm.startEditing }
                        })
                      : _vm._e()
                  ])
                ])
              ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }